<template>
  <div class="main">

      
    <div class="filter">
      <div class="filter-item">
        <div class="label">年度</div>
        <div class="content">
          <a class="node" :class="{active: year===''}" @click="yearChange('')">全部</a>
          <a class="node" :class="{active: year===item}" v-for="item in yearList" :key="item" @click="yearChange(item)">{{item}}</a>
        </div>
      </div>
      <div class="filter-item">
        <div class="label">月份</div>
        <div class="content">
          <a class="node" :class="{active: month===''}" @click="monthChange('')">全部</a>
          <a class="node" :class="{active: month===item}" v-for="item in monthList" :key="item" @click="monthChange(item)">{{item}}</a>
        </div>
      </div>
    </div>

    <div class="order-chart">
      <div class="head">
        <div class="title">配件退回数量</div>
      </div>
      <div class="block-content">
        <div class="block">
          <div class="block-header">
            <div class="block-head">
              <div class="block-title">配件退回总数</div>
              <div class="block-num">{{totalCount}}</div>
            </div>
            <div class="icon">
              <img src="@/assets/images/icon1.png" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="fee">
      <div class="home-title">
        <div class="left">
          配件退回
        </div>
        <div class="search">
        <el-input
            placeholder="请输入客户信息"
            v-model="customerName"
            class="input-with-select1 ml10"
            @keydown.enter.native="search"
          >
            <i
              class="el-icon-search el-input__icon"
              slot="suffix"
              @click="search"
            />
        </el-input>
      </div>
      </div>

      <el-table
          :data="tableData"
          style="width: 100%">

        <el-table-column
            prop="productName"
            label="产品型号"
            width="180">
        </el-table-column>
        <el-table-column
            label="客户信息">
          <template slot-scope="scope">
            <div>{{ scope.row.workOrder.contacts }}</div>
            <div>{{ scope.row.workOrder.phoneNumber }}</div>
            <div>{{ scope.row.workOrder.detailedAddress }}</div>
          </template>
        </el-table-column>
        <el-table-column
            prop="accessoryName"
            label="退回物品"
            width="180">
        </el-table-column>
        <el-table-column
            prop="expressCompany"
            label="物流公司">
        </el-table-column>
        <el-table-column
            prop="expressNo"
            label="物流单号">
        </el-table-column>
        <el-table-column
            prop="remark"
            label="退回备注">
        </el-table-column>

<!--        <el-table-column-->
<!--            label="操作">-->
<!--          <template slot-scope="scope">-->
<!--            <el-button-->
<!--                class="aaa"-->
<!--                @click.native.prevent="detail(scope.row.id)"-->
<!--                type="text"-->
<!--                size="small">-->
<!--              详情-->
<!--            </el-button>-->
<!--          </template>-->
<!--        </el-table-column>-->
      </el-table>
      <el-pagination
          class="pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-size="size"
          layout="total, sizes, prev, pager, next"
          :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      year: '',
      month: '',
      yearList: [],
      monthList: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
      taskType: '',
      totalCount: 0,
      installCount: 0,
      installCountCompleted: 0,
      installCountUnCompleted: 0,
      repairCount: 0,
      repairCountCompleted: 0,
      repairCountUnCompleted: 0,
      exchangeCount: 0,
      exchangeCountCompleted: 0,
      exchangeCountUnCompleted: 0,
      customerIncome: 0,
      tableData: [],
      page: 1,
      size:10,
      total: 0,

      customerName:""
    }
  },
  watch:{
    page(newVal, oldVal){//当前msg变量的值改变出发函数
      sessionStorage.setItem(
          "my-page",
          JSON.stringify({ "my-page-number": newVal })
      );
    },
    year(newVal, oldVal){//当前msg变量的值改变出发函数
      sessionStorage.setItem(
          "year",
          JSON.stringify({ "year": newVal })
      );
    },
    month(newVal, oldVal){//当前msg变量的值改变出发函数
      sessionStorage.setItem(
          "month",
          JSON.stringify({ "month": newVal })
      );
    },
  },

  created(){
    // this.getData()
    const year = new Date().getFullYear()
    for(let i=year;i>=2021;i--){
      this.yearList.push(i)
    }
    if(!JSON.parse(sessionStorage.getItem("year"))) {
      const year = new Date().getFullYear()
      this.year=year
    }
    this.getSessionStorage()

  },
  beforeMount() {
    if(!JSON.parse(sessionStorage.getItem("month"))) {
      const mounth = this.monthList[new Date().getMonth()]
      this.monthChange(mounth)
    }else {
      this.getData()
    }

  },
  methods: {
    search(){
      this.page=1
      this.getData()
    },
    getSessionStorage() {
      let myPage = JSON.parse(sessionStorage.getItem("my-page"));
      if (myPage){
        let myPageNumber = myPage["my-page-number"];
        this.page = myPageNumber;
      }
      let year = JSON.parse(sessionStorage.getItem("year"));
      if (year) {
        let yearNumber = year["year"];
        this.year = yearNumber;
      };
      let month = JSON.parse(sessionStorage.getItem("month"));
      if (month){
        let monthNumber = month["month"];
        this.month = monthNumber;
      }
      let taskType = JSON.parse(sessionStorage.getItem("taskType"));
      if (taskType){
        let taskTypeNumber = taskType["taskType"];
        this.taskType = taskTypeNumber;
      }
      this.getData()
    },
    getData(){
      this.$axios.get('/workOrder/return/list',{
        params: {
          year: this.year||'',
          month: this.month?`${this.year}-${this.month}`:'',
          page: this.page,
          size: this.size,
          customerName:this.customerName
        }
      }).then(res=>{
        this.customerIncome = res.data.customerIncome
        this.tableData = res.data.list
        this.total = res.data.total
        this.totalCount = res.data.total || 0
      })
    },
    yearChange(val){
      if(this.year!==val){
        this.year=val
        this.page = 1
        this.getData()
        sessionStorage.setItem(
            "year",
            JSON.stringify({ "year": this.year })
        );
      }else {
        sessionStorage.setItem(
            "year",
            JSON.stringify({ "year": '' })
        );
      }

    },
    monthChange(val){
      if(this.month!==val&&this.year){
        this.month=val
        this.page = 1
        this.getData()
        sessionStorage.setItem(
            "month",
            JSON.stringify({ "month": this.month })
        );
      }else {
        sessionStorage.setItem(
            "month",
            JSON.stringify({ "month": '' })
        );
      }

    },
    typeChange(val){
      if(this.taskType!==val){
        this.taskType=val
        this.page = 1
        this.getData()
        sessionStorage.setItem(
            "taskType",
            JSON.stringify({ "taskType": this.taskType })
        );
      }else {
        sessionStorage.setItem(
            "taskType",
            JSON.stringify({ "taskType": '' })
        );
      }

    },
    handleSizeChange(val) {
      this.page = 1
      this.size = val
      this.getData()
    },
    handleCurrentChange(val) {
      sessionStorage.setItem(
          "my-page",
          JSON.stringify({ "my-page-number": val })
      );
      this.page = val
      this.getData()
    },
    detail(id){
      this.$router.push(`/myorder/${id}`)
    },
  }
}
</script>
<style>
  .el-input__icon{
    cursor: pointer;
  }
</style>
<style lang="scss" scoped>
.aaa {
  color: #606266 !important;
}
.main{
  margin: 45px auto;
  width: 1080px;
  padding: 0 40px;
  background-color: #fff;
  .search{
    width: 300px;
    // padding-top: 15px;
    // padding-bottom: 15px;
  }
  .filter{
    padding: 20px 0;
    .filter-item{
      display: flex;
      border-bottom: 1px solid #eee;
      padding: 10px 0;
      .label{
        width: 100px;
        color: #999;
      }
      .content{
        display: flex;
        .node{
          padding: 0 20px;
          color: #333;
          min-width: 57px;
          cursor: pointer;
          &.active{
            color: #5574FF;
          }
        }
      }
    }
  }
}
.order-chart {
  margin-top: 28px;
  .head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: 1;
    margin-bottom: 20px;
    .title {
      font-size: 20px;
      color: #222;
    }
    .more {
      font-size: 16px;
      color: #777;
      cursor: pointer;
    }
  }
  .block-content {
    display: flex;
    justify-content: space-between;
    .block {
      width: 235px;
      height: 150px;
      padding: 0 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-direction: column;
      background-color: #FAFAFA;
      border-radius: 10px;
      .block-header {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 20px 0;
        .block-head {
          .block-title {
            font-size: 16px;
            color: #777;
          }
          .block-num {
            font-size: 32px;
            color: #333;
            font-weight: bold;
          }
        }
        .icon{
          width: 50px;
          height: 50px;
          border-radius: 50%;
          overflow: hidden;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
      &:nth-child(1) .block-header .icon{
        background-color: #BFF8DB;
      }
      &:nth-child(2) .block-header .icon{
        background-color: #E5ECFB;
      }
      &:nth-child(3) .block-header .icon{
        background-color: #FBEDE0;
      }
      &:nth-child(4) .block-header .icon{
        background-color: #FEF0F7;
      }
      .col-block {
        width: 100%;
        display: flex;
        justify-content: space-between;
        padding: 10px 0;
        border-top: 1px solid #e7e7e7;
        .col-item {
          // flex: 1;
          display: flex;
          align-items: center;
          font-size: 14px;
          color: #999;
          justify-content: center;
          span {
            font-size: 16px;
            color: #333;
            margin-left: 7px;
          }
        }
      }
    }
  }
}
.fee{
  margin-top: 48px;
  .home-title{
    font-size: 20px;
    color: #222;
    line-height: 1;
    padding-bottom: 22px;
    border-bottom: 1px solid #eee;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .total-amount{
    text-align: right;
    font-size: 14px;
    color: #222;
    font-weight: bold;
    padding: 30px 0 20px;
    .number{
      font-size: 18px;
    }
  }
}
.pagination{
  padding: 40px 0;
  text-align: right;
}
</style>
